jQuery(document).ready(function(e) {
 var t = e("input[name=option-2]:checked").val(),
     n = e("input[name=option-2]:checked").data("barcode");
 e("#swatch-name").html(t), e("#swatch-desc").html(n);
 var r = e("input[name=option-2]:checked").data("img");
 e(".slide.slick-slide").each(function() {
     var t = e(this).find("img").attr("src");
     r == t && (console.log("this is default below 1" + r), e(this).trigger("click"))
 }), e(".swatch input").change(function() {
     e("input[name=option-2]").parent().removeClass("active"), e("input[name=option-1]").parent().removeClass("active"), e("input[name=option-0]").parent().removeClass("active"), e("input[name=option-2]:checked").parent().addClass("active"), e("input[name=option-1]:checked").parent().addClass("active"), e("input[name=option-0]:checked").parent().addClass("active");
     var t = e("input[name=option-2]:checked").val(),
         n = e("input[name=option-1]:checked").val(),
         r = (s = e("input[name=option-0]:checked").val()) + " / " + n + " / " + t;
     e("[data-master-select]").find("option").each(function() {
         e(this).text() == r && e("[data-master-select]").val(e(this).val()).trigger("change")
     });
     var i = e("input[name=option-2]:checked").val();
     e("#swatch-name").html(i);
     var o = e("input[name=option-2]:checked").data("barcode");
     e("#swatch-desc").html(o);
     var a = e("input[name=option-2]:checked").data("img");
     e(".slide.slick-slide").each(function() {
         var t = e(this).find("img").attr("src");
         a == t && e(this).trigger("click")
     });
     t = e(this).parent().find("input[name=option-2]:checked").val(), n = e(this).parent().find("input[name=option-1]:checked").val();
     var s = e(this).parent().find("input[name=option-0]:checked").val(),
         u = e(this).parent().parent().parent().find("#totl-vr").val().split("/"),
         c = (u[0], u[1]),
         l = u[2],
         f = (e(this).val(), s + " /" + c + "/" + l);
     e("[data-master-select]").find("option").each(function() {
         e(this).text() == f && (e("[data-master-select]").find("option").removeAttr("selected"), e(this).attr("selected", "selected"), e("[data-master-select]").val(e(this).val()).trigger("change"))
     })
 })
}),
toggle_in_stock_message = function() {
  var parent_section = $('select.product-form__master-select').parents('.shopify-section');
  var product = JSON.parse(parent_section.find('[data-product-json]').html());
  var selected_option = $('select.product-form__master-select option:selected');
  var stockvar = parseInt(selected_option.attr('data-stock'));
  var selected_variant = product.variants.find(variant => variant.id == selected_option[0].value);

  var restock_tag = `NoRestock_${selected_variant.sku}`;
  var rst = selected_option.attr('data-inplc');
  var arr = rst.split('/');
  parent_section.find('.in-stock-message').hide();

  var members_only_tag = `MembersOnly_${selected_variant.sku}`;
  var show_members_only = false;
  if (product.tags.includes(members_only_tag)) {
    show_members_only = true;
  }

  // var product_available = true;
  // if (product.tags.includes(restock_tag)) {
  //   product_available = false;
  // }
  var product_available = selected_variant.available;

  const oosWarnings = JSON.parse(parent_section[0].querySelector('[data-warnings]').innerHTML);
  const oosMesssage = parent_section[0].querySelector('.oos-message[data-message]');

  oosMesssage.setAttribute('hidden', true);

  if(rst.indexOf('continue') != -1 || product_available){
    
    $('[data-out-of-stock-message]').hide();
    $(".email_signup3").hide();

    if (show_members_only && $('[data-members-only-button]').length) {
      $('.add_cart').addClass('hide').removeClass('show');
      $('[data-members-only-button]').show();
    } else {
      $('.add_sub').removeClass('show');
      $('.add_sub').addClass('hide');
      $('.add_cart').removeClass('hide');
      $('.add_cart').addClass('show');
      $('[data-members-only-button]').hide();
    } 

    if (stockvar <= 0) {
      oosMesssage.removeAttribute('hidden');
      oosMesssage.innerHTML = oosWarnings[selected_variant.id];
    } else {
      const inStockMessage = parent_section.find('.in-stock-message');
      const inStockMessageHTML = inStockMessage.find('.in-stock-message-text');
      if (!inStockMessage.hasClass('preorder')) {
        let inventoryCount = stockvar;
        if (stockvar > 10) {
          inStockMessage.removeClass('low-stock');
          inventoryCount = '>10';
        } else {
          inStockMessage.addClass('low-stock');
        }
        const inStockMessageContent = theme.strings.inStockMessage.replace('[count]', inventoryCount);
        inStockMessageHTML.html(inStockMessageContent);
      }
      inStockMessage.show();
    }
  } else {
    $('.add_cart').removeClass('show');
    $('.add_cart').addClass('hide');
    $('[data-out-of-stock-message]').show();
    $(".email_signup3").show();
    $('.add_sub').removeClass('hide');
    $('.add_sub').addClass('show')
    $('[data-members-only-button]').hide();
  }
}

if($('[data-section-type="product-template"]').length) {
  toggle_in_stock_message();
}

window.customer_warehouse = '';
switch_country = function(customer_country) {
  // var current_country_code = $('[name="country_code"]').val();
  // if (customer_country) {
  //   if (customer_country != current_country_code && !theme.design_mode && !sessionStorage.customer_changed_market) {
  //     $('[name="country_code"]').val(customer_country);
  //     $('[name="country_code"]').parents('form').submit();
  //     sessionStorage.customer_changed_market = true;
  //   }
  // }
  if($('[data-shipping-info-changer]').length) {
    $('[data-shipping-info-changer]').each(function(){
      if($(this).val() != customer_country) {
        country_option = $(this).find(`[data-country-code="${customer_country}"]`);
        if(country_option) {
          country_option_value = country_option.val();
          this.selectedIndex = country_option.index();
          $(`.shipping-info.${$(this).val()}`).removeClass('hidden').siblings('.shipping-info').addClass('hidden');
        }
      }
    });
  }
};

toggle_vat_message = function(customer_country) {
  if (customer_country == 'GB' || window.customer_warehouse == 'EU') {
    $('[data-vat-message]').fadeIn();
  }
}

runCountrySpecificCode = function(country_codes) {
  switch_country(country_codes);

  if("US" === country_codes){
    $(".wus.us" + country_codes).css("display", "block"), jQuery(".der38").css("display", "none"),
    window.customer_warehouse = "US";
    $('body').addClass('us-based-customer');
  } else if("FR" === country_codes || "CH" === country_codes || "DE" === country_codes || "TR" === country_codes || "IT" === country_codes || "ES" === country_codes || "PL" === country_codes || "UA" === country_codes || "RO" === country_codes || "KZ" === country_codes || "NL" === country_codes || "BE" === country_codes || "GR" === country_codes || "CZ" === country_codes || "SE" === country_codes || "PT" === country_codes || "HU" === country_codes || "BG" === country_codes || "RS" === country_codes || "DK" === country_codes || "FI" === country_codes || "SK" === country_codes || "SI" === country_codes  || "NO" === country_codes || "IE" === country_codes || "HR" === country_codes || "GE" === country_codes || "EE" === country_codes || "LU" === country_codes || "IS" === country_codes || "MT" === country_codes || "CY" === country_codes || "LT" === country_codes || "LV" === country_codes || "AL" === country_codes || "MD" === country_codes || "BA" === country_codes || "AM" === country_codes || "MK" === country_codes || "ME" === country_codes || "XK" === country_codes || "CY" === country_codes || "AZ" === country_codes || "AD" === country_codes || "LI" === country_codes || "MC" === country_codes || "VA" === country_codes){
   $(".wus.usEU").css("display", "block"), jQuery(".der38").css("display", "none");
   window.customer_warehouse = "EU";
  } else {
    $(".wus.usHK").css("display", "block").addClass('country-code');
    window.customer_warehouse = "HK";
  }

  toggle_vat_message(country_codes);

  /* English T1 GEOs */
  "US" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 4-7 DAYS <strong>US</strong> SHIPPING") :
  "NZ" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-9 DAYS SHIPPING TO <strong>NZ</strong>") :
  "AU" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-9 DAYS SHIPPING TO <strong>AUSTRALIA</strong> CUSTOM/TAX LIKELY APPLY") :
  "CA" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-9 DAYS SHIPPING TO <strong>CA</strong>. CUSTOM/TAX LIKELY APPLY") :
  

    /* Europe */
     
  "GB" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 4-7 DAYS SHIPPING TO <strong>UK</strong>") :
  "NL" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 2-5 DAYS SHIPPING TO <strong>THE NETHERLANDS</strong>") :
  "AT" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 3-8 DAYS SHIPPING TO <strong>AUSTRIA</strong>") :
  "FR" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 3-6 DAYS SHIPPING TO <strong>FRANCE</strong>") :
  "PL" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 3-5 DAYS SHIPPING TO <strong>POLAND</strong>") :
  "DE" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 3-5 DAYS SHIPPING TO <strong>GERMANY</strong>") :
  "IT" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-12 DAYS SHIPPING TO <strong>ITALY</strong>") :
  "BE" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-11 DAYS SHIPPING TO <strong>BELGIUM</strong>") :
  "ES" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 4-8 DAYS SHIPPING TO <strong>SPAIN</strong>") :
  "CZ" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-11 DAYS SHIPPING TO <strong>CZECH REPUBLIC</strong>") :  
  "TR" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-10 DAYS SHIPPING TO <strong>TURKEY</strong>") :
  "IE" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-10 DAYS SHIPPING TO <strong>IRELAND</strong>") :
  "PT" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-10 DAYS SHIPPING TO <strong>PORTUGAL</strong>") :
  "FI" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-10 DAYS SHIPPING TO <strong>FINLAND</strong>") :
  "NO" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-10 DAYS SHIPPING TO <strong>NORWAY</strong>") :
  "SK" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 7-13 DAYS SHIPPING TO <strong>SLOVAKIA</strong>") :
  "SE" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-10 DAYS SHIPPING TO <strong>SWEDEN</strong>") :
  "DK" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-10 DAYS SHIPPING TO <strong>DENMARK</strong>") :
  "CH" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-8 DAYS SHIPPING TO <strong>SWITZERLAND</strong>") :
  "EE" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-13 DAYS SHIPPING TO <strong>ESTONIA</strong>") :  
  "IS" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 15-26 DAYS SHIPPING TO <strong>ICELAND</strong>") :
  "LT" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-13 DAYS SHIPPING TO <strong>LITHUANIA</strong>") :
  "LV" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 6-13 DAYS SHIPPING TO <strong>LATVIA</strong>") :
  "GR" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 9-14 DAYS SHIPPING TO <strong>GREECE</strong>") :
  
    /* Asia */
  "TW" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5 DAYS SHIPPING TO <strong>TAIWAN</strong>") :
  "SG" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 3-6 DAYS SHIPPING TO <strong>SINGAPORE</strong>") :
  "HK" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 2-3 DAYS SHIPPING TO <strong>HONG KONG</strong>") :  
  "JP" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 3-5 DAYS SHIPPING TO <strong>JAPAN</strong>") :
  "KR" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-14 DAYS SHIPPING TO <strong>SOUTH KOREA</strong>") :

    /* GCC */
  "BH" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 7-13 DAYS SHIPPING TO <strong>BAHRAIN</strong>") :
  "KW" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 7-11 DAYS SHIPPING TO <strong>KUWAIT</strong>") :
  "OM" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 9-25 DAYS SHIPPING TO <strong>OMAN</strong>") :
  "QA" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 7-8 DAYS SHIPPING TO <strong>QATAR</strong>") :
  "SA" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-9 DAYS SHIPPING TO <strong>SA</strong>") :
  "AE" === country_codes ? jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE 5-9 DAYS SHIPPING TO <strong>UAE</strong>") :

  jQuery(".announcement-bar__message").html("💕 Get Valentine's Day Ready ✈️ FREE WORLDWIDE SHIPPING");
}

window.customerCountry = sessionStorage.customerCountry;
if (!customerCountry) {
  $.getJSON("https://ipapi.co/json/").done(function(e) {
    sessionStorage.customerCountry = e.country_code;
    console.log(e.country_code);
    runCountrySpecificCode(e.country_code);
  });
} else {
  runCountrySpecificCode(window.customerCountry);
}


$(document).ready(function() {
 if (/*$("body").on("click", "#sil-btn", function() {
         $("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_gld").removeClass("hide-me"), $(".list_blk").removeClass("hide-me"), $(".list_sil").toggleClass("hide-me")
     }), $("body").on("click", "#gld-btn", function() {
         $("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_blk").removeClass("hide-me"), $(".list_gld").toggleClass("hide-me")
     }), $("body").on("click", "#blk-btn", function() {
         $("#more-color-div ul li").removeClass("active"), $(this).parent().addClass("active"), $(".list_sil").removeClass("hide-me"), $(".list_gld").removeClass("hide-me"), $(".list_blk").toggleClass("hide-me")
     }),*/

     $("body").on("click", ".my-additional-btn", function() {
         var e = $(this).data("vrnt");
         data = {
             quantity: 1,
             id: e
         }, jQuery.ajax({
             type: "POST",
             url: "/cart/add.js",
             data: data,
             dataType: "json",
             success: function() {
                 window.location.href = "/cart"
             }

         })
     }), $("body").on("change", ".cart-swatch.swatch-element input", function() {
        var parent_section = $('[data-master-select]').parents('.shopify-section');
        var e = $(this).parent().data("varid");
        if($(".list-1").length < 1){
          $('select.product-form__master-select').val(e);
          $('input#k_id_sku').val($(this).parent().attr('data-skk'));
          $('select.product-form__master-select').val(e);
        }else{
          
          var xtext = $(".list-0 .swatch-element.active input").val();
          var xtext1 = $(".list-1 .swatch-element.active input").val();
          var txt2 = xtext +" / "+ xtext1;

          var selected_option = Array.from($('[data-master-select] option')).find(option => option.textContent.includes(txt2));
          
          if(selected_option) {
            $('[data-master-select]').val(selected_option.value).trigger('change');
            $('input#k_id_sku').val(selected_option.dataset.sku);
            parent_section.find('[data-cart-submit]').prop('disabled', false);
            parent_section.find('[data-cart-submit] [data-cart-primary-submit-text]').show().siblings().hide();
            var htm_cart_btn = $('.price--'+selected_option.value).html();
            $('.prdistxt').html(htm_cart_btn);
            var members_only_btn_html = $(`.members-only-html--${selected_option.value}`).html();
            $('[data-members-only-button]').html(members_only_btn_html);
            toggle_in_stock_message();
          } else {
            console.log('variant does not exist');
            
            parent_section.find('[data-cart-submit]').prop('disabled', true).show();
            parent_section.find('[data-cart-submit] [data-submit-button-unavailable-text]').show().siblings().hide();
            parent_section.find('.in-stock-message').hide();
            parent_section.find('#email_signup3').hide();
            parent_section.find('[data-out-of-stock-message]').hide();
            parent_section[0].querySelector('.oos-message[data-message]').setAttribute('hidden', true);
          }
        }
        
        var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + $('select.product-form__master-select').val();
        window.history.replaceState({ path: newUrl }, '', newUrl);

     }), $(window).width() > 767) {
     $("body").on("click", "#more-btn", function() {
         var e = $(".sec-half").height();
         e > $(".fst-half").height() ? $(".fst-half").height(e) : $(".fst-half").height(), $(".sec-half").height($(".fst-half").height())
     });
 }
});

$('.color-slider-click.clk, .color-slider-click.ckl').click(function(){
	product_item = $(this).parents('[data-product-item]');
  if($(this).hasClass('clk')) {
		$(this).addClass('active').siblings().removeClass('active');
	} else {
		$(this).addClass('active1').siblings().removeClass('active1');
	}

	var xttext1 = product_item.find('.active').text();
	var xtext = product_item.find('.active1').text();

	var txt2 = xttext1 +" / "+ xtext;

	product_item.find('select.slider--col option').each(function(){
		var txt = $(this).text();
		if(txt.indexOf(txt2) != -1){
			var variant_id =  $(this).val();
			var stck = $(this).data('stock');
			var price = $(this).data('price');
			var compare_at_price = $(this).data('compare-at-price');

			product_item.find('.my-additional-btn').attr('data-vrnt', variant_id);
		  product_item.find('input.check--color').val(variant_id);
		  //console.log(stck);
			if(stck){
				if(stck.indexOf('deny') != -1){
					product_item.find('.my-additional-btn').text('Sold Out').css('pointer-events', 'none') ;
				}else{
					product_item.find('.my-additional-btn').text('ADD TO CART').css('pointer-events', '') ;
				}
			}


			$(this).parent().val(variant_id);
			product_item.find('[data-current-variant-price]').html(price);
			compare_at_price ? product_item.find('[data-current-variant-compare-at-price]').html(compare_at_price).show() : product_item.find('[data-current-variant-compare-at-price]').hide();

			var chkq = $(this).data('policy');
			if(chkq){
				if(chkq.indexOf('deny') != -1){
					if(product_item.find('input.check--color').prop("checked") == true){
						product_item.find('input.check--color').trigger('click');
					}
					product_item.find('input.check--color').attr('disabled', 'true');
				}else{
					product_item.find('input.check--color').removeAttr('disabled');
				}
			}
		}
	});
});

$('.clickk-col').click(function(){
if(!$(this).hasClass('c-active')){
$('.clickk-col').removeClass('c-active');
$('.tabcontent').removeClass('c--active');
$(this).addClass('c-active').next().addClass('c--active');
}else{
 $(this).removeClass('c-active').next().removeClass('c--active');}
if($(this).next().next().hasClass('fr-strap')){
   if($(this).next().next().hasClass('fr02')){
$(this).next().next().removeClass('fr02');
   }else{
$(this).next().next().addClass('fr02');
}
}
if($(this).hasClass('fr02')){
$(this).removeClass('fr02')
}
});

$('span.size--gide-main').click(function(){
$('.abu').show();
});
$('.ab-close').click(function(){
$('.abu').hide();
$('.abu-ques').hide();
});

$('.list-0 span.qusmark').click(function(){
$('.abu-ques').show();
});


// setTimeout(function(){
// var vl = $('select[name="currencies"]').val();
// console.log(vl);
// $('select[name="currencies"] option[value="'+vl+'"]').trigger('chnage');

//   $('span.primary-text.prdistxt').html($('.pri---price').html());
// }, 5000);

$('[data-shipping-info-changer]').change(function(e){
$(`.${$(this).val()}`).removeClass('hidden').siblings('.shipping-info').addClass('hidden');
});

$(document).on('click', '.custom-footer-opener, .custom-faq-question-title', function(e) {
e.preventDefault();
$(this).toggleClass('opened');
$(this).next().slideToggle();
});

document.addEventListener('DOMContentLoaded', function(){

	function set_element_height_into_variable(parent_container, element_to_measure, css_var_name) {
    height = $(element_to_measure).outerHeight(true);
    $(parent_container)[0].style.setProperty(`--${css_var_name}`, height + 'px');
  }

	set_element_height_into_variable('body', '#shopify-section-custom-header', 'header_height');


	$(window).on('load', function(){
    set_element_height_into_variable('body', '#shopify-section-custom-header', 'header_height');
  });

  $(window).on('resize', function(){
    set_element_height_into_variable('body', '#shopify-section-custom-header', 'header_height');
  });

	if(!sessionStorage.getItem("announcement-bar-hidden")) {
		$('.announcement-bar').slideDown();
	}

	$(document).on('click', '.announcement-bar__close', function(e) {
		e.preventDefault();
		$('.announcement-bar').slideUp();
		sessionStorage.setItem("announcement-bar-hidden", !0);
	});

	$(document).on('click', '[data-open-mobile-menu]', function(e) {
		e.preventDefault();
		$('[data-header-overlay]').fadeIn();
		$('.custom-mobile-sidebar').addClass('opened');
	});

	$(document).on('click', '[data-close-mobile-menu]', function(e) {
		e.preventDefault();
		$('[data-header-overlay]').fadeOut();
		$('.custom-mobile-sidebar').removeClass('opened');
	});

	$(document).on('click', '[data-next-level]', function(e) {
		e.preventDefault();
		next_level_menu = $(this).data('next-level');
		new_title = $(this).data('title');
		$('[data-sidebar-header]').html(new_title);
		$('.custom-mobile-sidebar').removeClass('level-1-visible').addClass('level-2-visible');
		$('.cms-body-content.level-2').removeClass('visible');
		$(`[data-parent-link="${next_level_menu}"]`).addClass('visible');
	});

	$(document).on('click', '[data-sidebar-previous-level]', function(e) {
		e.preventDefault();
		new_title = $('[data-sidebar-header]').data('title');
		$('[data-sidebar-header]').html(new_title);
		$('.cms-body-content.level-2').removeClass('visible');
		$('.custom-mobile-sidebar').removeClass('level-2-visible').addClass('level-1-visible');
	});

  $(document).on('click', '[data-cart-submit]', function(e) {
    if (window.attentive && window.customer && $('[data-product-json]').length) {
      product = JSON.parse($('[data-product-json]').text());
      variant_id = $('[name="id[]"').val();
      window.attentive.analytics.addToCart(
        {
          items: [
            {
              productId: product.id,
              productVariantId: variant_id,
              name: product.title,
              productImage: product.featured_image,
              category: product.type,
              price: {
                value: product.price / 100,
                currency: Shopify.currency.active
              },
              quantity: 1
            }
          ],
          user: {
            phone: window.customer.phone
          }
        }
      );
    }
  });


  // Product quickshop

  var Shopify = Shopify || {};
  // ---------------------------------------------------------------------------
  // Money format handler
  // ---------------------------------------------------------------------------
  Shopify.money_format = theme.moneyFormat;
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };


  $(document).on('click', '[data-open-product-quickshop-modal]', function(e) {
    e.preventDefault();
    var product_item = $(this).parents('[data-product-item]');
    $('body').addClass('quickshop-opened');
    setTimeout(function(){
      product_item.find('[data-product-quickshop-modal]').addClass('opened');
    }, 500);
  });

  $(document).on('click', '[data-close-product-quickshop-modal]', function(e) {
    e.preventDefault();
    var product_item = $(this).parents('[data-product-item]');
    product_item.find('[data-product-quickshop-modal]').removeClass('opened');
    setTimeout(function(){
      $('body').removeClass('quickshop-opened');
    }, 300);
  });

  $(document).on('click', '[data-open-size-guide]', function(e) {
    e.preventDefault();
    var product_modal = $(this).parents('[data-product-quickshop-modal]');
    var product_handle = $(this).data('open-size-guide');
    var size_guide_type = $(this).data('size-guide-type');
    if (size_guide_type == 'case') {
      var size_guide_class = '.abu-ques'
    } else {
      var size_guide_class = '.abu'
    }
    var time = Date.now();
    fetch(`${theme.routes.rootUrl}/products/${product_handle}?section_id=product-template&timestamp=${time}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(response) {
      return response.text();
    })
    .then(function(text) {
      var size_guide_image = $(text).find(`${size_guide_class} .abu-popup-content`).html();
      product_modal.find('.pqm-size-guide-modal-content').html(size_guide_image);
      product_modal.find('[data-size-guide]').show();
    })
    .catch(function(error) {
      // eslint-disable-next-line no-console
      console.log(error);
    });
  });

  $(document).on('click', '[data-close-size-guide]', function(e) {
    var product_modal = $(this).parents('[data-product-quickshop-modal]');
    product_modal.find('[data-size-guide]').fadeOut();
  });

  $(document).on('click', '.custom-product-card__toggle-alternate-image', function(e) {
    e.preventDefault();
    product_item = $(this).parents('[data-product-item]');
    if ($(this).hasClass('custom-product-card__toggle-alternate-image--left')) {
      product_item.addClass('custom-product-card__image--primary-visible').removeClass('custom-product-card__image--alternate-visible');
    } else {
      product_item.addClass('custom-product-card__image--alternate-visible').removeClass('custom-product-card__image--primary-visible');
    }
  });

  $(document).on('click', '.pqm-option', function(){
  	$(this).addClass('selected').siblings().removeClass('selected');
    new_value = $(this).data('value');
  	option_container = $(this).parents('.pqm-option-container');
  	option_container.attr('data-current-value', new_value);
    parent_section = $(this).parents('[data-product-quickshop-modal]');
  	update_main_selector(parent_section);
  });

  $(document).on('submit','.pqm-form', function(e) {
    e.preventDefault();
    addItemToCart($(this));
  });

  function update_main_selector(parent_section){
  	option_string = 'option';

  	parent_section.find('.pqm-option-container').each(function(){
  		option_string += `[data-${$(this).data('option-index')}="${$(this).attr('data-current-value')}"]`;
  	});

  	option = parent_section.find('.pqm-form-select').find(option_string);

  	if(option.length) {
  		value = option.val();
  		parent_section.find('.pqm-form-select').val(value);
  		update_add_to_cart_button(parent_section.find('.pqm-form-select'), parent_section);
  	} else {
      parent_section.find('.pqm-submit-button').addClass('unavailable');
  		parent_section.find('.pqm-submit-button').prop('disabled', true);
  		parent_section.find('.pqm-sb-text').html(theme.quickshop.unavailable);
  	}
  }

  function update_add_to_cart_button(selector, parent_section) {
  	var variantId = selector.val();
    var product_json_id = '#' + parent_section.find('[data-product-json]')[0].id;
    var product = JSON.parse($(`${product_json_id}`).html());
  	var variant = get_variant_by_id(variantId, product_json_id);
  	parent_section.find('.pqm-submit-button').removeClass('unavailable');
    parent_section.find('[data-variant-price]').html(Shopify.formatMoney(variant.price));

    if(variant.compare_at_price && variant.compare_at_price > variant.price) {
      parent_section.find('[data-variant-compare-at-price]').show().html(Shopify.formatMoney(variant.compare_at_price));
    } else {
      parent_section.find('[data-variant-compare-at-price]').hide();
    }

  	if(variant.available) {
  		parent_section.find('.pqm-submit-button').prop('disabled', false);
  		parent_section.find('.pqm-sb-text').html(theme.quickshop.addToCart);
  	} else {
  		parent_section.find('.pqm-submit-button').prop('disabled', true);
  		parent_section.find('.pqm-sb-text').html(theme.quickshop.soldOut);
  	}

    // warning messages for quickshop
    parent_section.find('.gtr').hide();
    var splitted_variant_title = variant.title.split('/');
    var message_class = '';
    if (splitted_variant_title.length > 1) {
      message_class = splitted_variant_title[0].replace(/[^a-zA-Z0-9]/g, '').replace(/\s/g, '')+splitted_variant_title[3].replace(/[^a-zA-Z0-9]/g, '').replace(/\s/g, '');
      message_class = message_class.replace(/[^a-zA-Z0-9]/g, '').replace(/\s/g, '');
    } else {
      if (splitted_variant_title == 'X & XS') {
        message_class = 'X';
      } else if (splitted_variant_title == 'Airpods') {
        message_class = 'Airpod';
      } else {
        message_class = splitted_variant_title.toString().replaceAll(' ','');
      }
    }
    parent_section.find(`.der${message_class}`).show();
  }

  function get_variant_by_id(variant_id, product_json_id) {
    var product = JSON.parse($(`${product_json_id}`).html());
    var result = product.variants.filter(obj => {
      return obj.id == variant_id;
    });
    var variant = result[0];
    return variant;
  }

  function addItemToCart(form) {
    var quickshop_modal = form.parents('[data-product-quickshop-modal]');
    var submit_button = form.find('[type="submit"]');
    submit_button.prop('disabled', true);
    fetch(theme.cartRoutes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: form.serialize()
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      if (json.status && json.status !== 200) {
        var error = new Error(json.description);
        error.isFromServer = true;
        throw error;
      }
      submit_button.prop('disabled', false).html(theme.quickshop.added);
      setTimeout(function(){
        quickshop_modal.removeClass('opened');
        setTimeout(function(){
          submit_button.html(theme.quickshop.addToCart);
          $('body').removeClass('quickshop-opened');
        }, 300);
      }, 1000);
      fetchCart();
    })
    .catch(function(error) {
      // eslint-disable-next-line no-console
      console.log(error);
    });
  }

  function fetchCart() {
    var time = Date.now();
    fetch(`${theme.cartRoutes.cartUrl}.json?timestamp=${time}`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      return response.json();
    }).then(function(cart) {
      if(cart.item_count > 0) {
        $('.chm-open-cart').addClass('not-empty');
      } else {
        $('.chm-open-cart').removeClass('not-empty');
      }
      $('[data-cart-count]').html(cart.item_count);
      $('[data-cart-count]').addClass('animate');
      setTimeout(function(){
        $('[data-cart-count]').removeClass('animate');
      }, 1000);
    });
  }

  // Cart featured collections
  $(document).on('click', '[data-open-featured-collection]', function(e) {
    e.preventDefault();
    var collection_to_display = $(this).data('open-featured-collection');
    $('[data-featured-collection-changer-container]').fadeIn();
    $('[data-featured-collections-header]').slideUp();
    $(`[data-featured-collection="${collection_to_display}"]`).show().siblings().hide();
    $(`[data-featured-collection="${collection_to_display}"]`).slick('refresh');
    $('[data-featured-collections]').fadeIn();
  });

  $(document).on('click', '[data-featured-collection-changer]', function(e) {
    e.preventDefault();
    $('[data-featured-collections-header]').slideDown();
    $('[data-featured-collections]').fadeOut();
    $('[data-featured-collection-changer-container]').fadeOut();
  });

  // Influencer announcement bar
  if ($('[data-influencers]').length) {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('influencer') || sessionStorage.show_influencer_announcement) {
      if (!sessionStorage.influencer_announcement_hidden) {
        var influencer_name = urlParams.get('influencer') || sessionStorage.show_influencer_announcement;
        var influencers = JSON.parse($('[data-influencers]').html());
        var influencer_announcement_bar = $('.influencer-announcement-bar');
        var message_container = $('.influencer-announcement-bar__message');
        if (influencers[influencer_name]) {
          sessionStorage.show_influencer_announcement = influencer_name;
          var influencer = influencers[influencer_name];
          var message = influencer.message;
          message_container.html(message);
          influencer_announcement_bar.css({'--color':influencer.color, '--background':influencer.background});
          influencer_announcement_bar.slideDown();
        }
      }
    }

    $(document).on('click', '.influencer-announcement-bar__close', function(e) {
      e.preventDefault();
      sessionStorage.influencer_announcement_hidden = true;
      $('.influencer-announcement-bar').slideUp();
    });
  }

  // Custom market change
  $(document).on('click', '[data-select-market]', function(e) {
    e.preventDefault();
    if (!$(this).hasClass('selected')) {
      sessionStorage.customer_changed_market = true;
      var new_market_code = $(this).data('select-market');
      $('[name="country_code"]').val(new_market_code);
      $('[name="country_code"]').parents('form').submit();
    }
  });

  // Collapsible
  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    e.preventDefault();
    collapsible_item = $(this).parents('[data-collapsible-item]');
    if(!collapsible_item.hasClass('opened')) {
      collapsible_item.siblings('.opened').removeClass('opened').find('[data-collapsible-content]').hide();
    }
    collapsible_item.find('[data-collapsible-content]').toggle();
    collapsible_item.toggleClass('opened');
  });

  // Product tabs
  $(document).on('click', '[data-product-tab]', function(e) {
    e.preventDefault();
    product_tabs = $(this).parents('[data-product-tabs]');
    currently_active_tab = product_tabs.find('[data-product-tab].active');
    currently_active_tab.removeClass('active');
    // Hide currently active tab content
    $(`#${currently_active_tab.data('product-tab')}`).hide();
    $(this).addClass('active');
    $(`#${$(this).data('product-tab')}`).fadeIn();
  });

  // Return policy popup for PDP
  $(document).on('click', '.template-product [data-toggle-product-return-popup]', function(e) {
    e.preventDefault();
    $('[data-product-return-popup]').toggleClass('opened');
  });

  // Shop pay widget popup
  $(document).on('click', '[data-toggle-shop-pay-popup]', function(e) {
    e.preventDefault();
    $('[data-shop-pay-popup]').toggleClass('opened');
  });

  $(document).on('click', '[data-toggle-sustainability-popup]', function(e) {
    e.preventDefault();
    $('[data-sustainability-popup]').toggleClass('opened');
  });

  $(document).on('click', '[data-toggle-adaptor-finish-popup]', function(e) {
    e.preventDefault();
    $('[data-adaptor-finish-popup]').toggleClass('opened');
  });

  $(document).on('click', '[data-toggle-bmsm-popup]', function(e) {
    e.preventDefault();
    $('[data-bmsm-popup]').toggleClass('opened');
  });

  $(document).on('click', '[data-toggle-new-address-popup]', function(e) {
    e.preventDefault();
    $('[data-new-address-popup]').toggleClass('opened');
  });

  $(document).on('click', '[data-toggle-edit-address-popup]', function(e) {
    e.preventDefault();
    popup_id = $(this).data('toggle-edit-address-popup');
    $(`[data-edit-address-popup="${popup_id}"]`).toggleClass('opened');
  });

  $(document).on('change', '[data-customer-nav]', function(e) {
    newUrl = $(this).val();
    window.location.href = newUrl;
  });

  const collectionPaginationIntersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const intersecting = entry.isIntersecting;
      if (!intersecting) return;
      
      fetch(`${entry.target.dataset.href}&section_id=${entry.target.dataset.sectionId}`, {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      }).then(function(response) {
        response.text().then(function(content) {
          var tempElement = document.createElement('div');
          tempElement.innerHTML = content;
          document.querySelector('#ProductsGrid').innerHTML += tempElement.querySelector('#ProductsGrid').innerHTML;
          if (tempElement.querySelector('[data-paginate-collection]')) {
            var newPaginationHref = tempElement.querySelector('[data-paginate-collection]').dataset.href;
            document.querySelector('[data-paginate-collection]').dataset.href = newPaginationHref;
          } else {
            document.querySelector('[data-paginate-collection]').remove();
          }
        });
      });
    })
  }, { rootMargin: "300px" });

  if (document.querySelector('[data-paginate-collection]')) {
    collectionPaginationIntersectionObserver.observe(document.querySelector('[data-paginate-collection]'));
  }
});

window.addEventListener("load", function(){
  if ($('.custom-faq-question').length && location.hash) {
    setTimeout(function(){
      $(window).scrollTop($(location.hash).offset().top);
      $(location.hash).find('.custom-faq-question-title').click();
    }, 500);
  }
});
